import * as jsondiffpatch from 'jsondiffpatch';

class CompareCabasView {
  constructor(options = {}) {
    const defaults = {
      enabledPages: ['.page--compare-cabas'],
      containerSelector: '.page--compare-cabas footer',
      oldContent: window.CabasEstimateOld,
      newContent: window.CabasEstimateNew,
      noDiffMessage: window.NoDiffMessage || '(no changes)'
    };
    Object.assign(this, defaults, options);

    if(document.body.matches(this.enabledPages.join(', '))) {
      this.init();
    }
  }

  init() {
    this.diffpatcher = jsondiffpatch.create({ objectHash: this.objectHash });

    // Choose the diff formatter. Alternatively, we could use jsondiffpatch.formatters.annotated
    // but ultimately we will want to create our own custom formatter, in order to display the
    // diff in a user-friendly manner (translated field names etc.)
    this.formatter = jsondiffpatch.formatters.html;
    jsondiffpatch.formatters.html.hideUnchanged();

    this.container = document.querySelector(this.containerSelector);

    if( // ensure both datas are present
      this.oldContent && typeof this.oldContent === 'object' &&
      this.newContent && typeof this.newContent === 'object'
    ) {
      const diffHTML = this.renderDiff(this.oldContent, this.newContent);
      if(diffHTML) {
        this.container.innerHTML = diffHTML;
      } else {
        this.container.innerHTML = this.noDiffMessage;
      }
    } else {
      // Diff data not available in the global object
    }
  }

  /**
   * @param {Object} oldContent - The old version of the data
   * @param {Object} newContent - The new version of the data
   * @return {String} - The diff report HTML
   */
  renderDiff(oldContent, newContent) {
    const delta = this.diffpatcher.diff(oldContent, newContent);
    return this.formatter.format(delta, oldContent);
  }

  /**
   * Creates an objectHash for diffpatcher.
   * {@link https://github.com/benjamine/jsondiffpatch/blob/master/docs/arrays.md}
   * @param {Object} obj - The object being read
   * @returns {String} - The object hash
   */
  objectHash(obj) {
    if(obj.Text) return obj.Text;
    const hash = Object.entries(obj).flatMap(i=>i).join('');
    return hash;
  }
}

export default CompareCabasView;
